import {Component} from 'react'

import MenuItems from './MenuItems'

import './index.css'

class NavBar extends Component {
  state = {clicked: false}

  handleClick = () => {
    const {clicked} = this.state
    this.setState({clicked: !clicked})
  }

  render() {
    const {clicked} = this.state

    return (
      <nav className="header">
        <img
          src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1639815225/newlyweds_wfyvcs.png"
          alt="logo"
          className="logo"
        />

        <button className="menu-icon " type="button" onClick={this.handleClick}>
          <i className={clicked ? ' fas fa-times' : 'fas fa-bars'} />
        </button>
        <ul className={clicked ? 'nav-menu active' : 'nav-menu'}>
          {MenuItems.map(eachItem => (
            <li key={eachItem.id}>
              <a className={eachItem.cName} href={eachItem.url}>
                {eachItem.title}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    )
  }
}

export default NavBar
